import Entity from '../entity'
import SaleOrderRequestLine from './sale-order-request-line'

export default class SaleOrderRequestDetail extends Entity<number>{
    code: string;
    externalCode: string;
    statusCode: string;
    orderDate: Date;
    ExpectedDeliveredDate:Date;
    customerId :number;
    note: string;
    contactName: string;
    contactPhone : string;
    shippingFullAddress: string;
    shippingAddressNo: string;
    shippingProvinceId :number;
    shippingDistrictId :number;
    shippingWardId:number | null;
    assetTypeCode: string;
    conditionTypeCode : string;
    departmentId :number;
    customerAreaId :number;
    salesmanId :number;
    salesmanVersion : string;
    discountType: string;
    discountVal :number;
    amount :number;
    taxAmount :number;
    totalAmount:number;
    totalAmountPaid:number;
    prePaymentAmount:number;
    paymentMethodCode : string;
    customerCode : string;
    customerName : string;
    customerChannelId :number;
    customerTypeId :string;
    customerGroupId :number;
    ceatorUserName : string;
    lastModifierUserName : string;
    clientCode: string;
    autoCreateSo :boolean;
    inputChannelCode : string;
    outboundMode : string;
    allowLockNegative :boolean;
    aoGroupCode:string;
    warehouseCode: string;
    creatorUserName:string;
    creatorName:string;
    creationTime: Date;
    lines : Array<any> = [];
    histories : Array<any> = [];
    customer :any;
    client:any;
    shippingNote:string;
    packingNote:string;
    processWarehouseCode: string;
    warrantyInfo :string;
}
